import { render } from "./message-item.vue?vue&type=template&id=243d92cd&scoped=true"
import script from "./message-item.vue?vue&type=script&lang=js"
export * from "./message-item.vue?vue&type=script&lang=js"

import "./message-item.vue?vue&type=style&index=0&id=243d92cd&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243d92cd"]])

export default __exports__